module.exports = __webpack_public_path__ + "img/box-arrow-up-right.97bcb5e5.svg";